module.exports = __webpack_public_path__ + "img/Frame 1048three.3ac88c78.png";